<template>
    <v-container>
        <v-row>
            <v-col cols="12" class="text-left">

                <h2 color="secondary"><small>Descubre los restaurantes de</small></h2>
                <h1>{{ this.nombreCiudad }}</h1>

                <br>
                <v-divider></v-divider>
                <br>

                <v-row>            
                    <v-col cols="12" v-for="(comercio,index) in comercios" :key="index">
                        <v-card
                            class="mx-auto"
                            max-width="400"
                            elevation="6"
                            @click="irRestaurante(comercio.slug)"
                            
                        >
                            <div v-if="comercio.image == null">
                                <v-img
                                class="white--text align-end"
                                height="200px"
                                src="@/assets/img/restaurant/restaurant-default.jpg"
                                >
                                </v-img>
                            </div>
                            <div v-else>
                                <v-img
                                class="white--text align-end"
                                height="200px"
                                :src="comercio.img_uri_commerce+'/'+comercio.image"
                                >
                                </v-img>
                            </div>

                            <v-row>
                                <v-col cols="3" 
                                    class="my-auto mx-auto"
                                >
                                    <div v-if="comercio.logo == null">
                                        <v-avatar 
                                        size="60">
                                            <img
                                                src="@/assets/img/restaurant/logo-default.jpg"
                                            >
                                        </v-avatar>
                                    </div>
                                    <div v-else>
                                        <v-avatar 
                                        size="60">
                                            <img
                                                :src="comercio.img_uri_commerce+'/'+comercio.logo"
                                            >
                                        </v-avatar>
                                    </div>
                                </v-col>
                                <v-col cols="8" class="pl-0">
                                    <v-card-title class="pl-0">{{comercio.name}}</v-card-title>
                                    <v-card-subtitle class="pl-0">{{ comercio.address }}</v-card-subtitle>
                                </v-col>
                            </v-row>
                        
                        </v-card>
                    </v-col>
                </v-row>

            </v-col>
        </v-row>
    </v-container>
</template>


<script>
    import store from '@/store/index';
    import { comercio_api } from '@/api/comercio';
    import { ciudad_api } from '@/api/ciudades';

    export default {
        name: 'Localidad',
        data () {
            return {
                comercios: '',
                ciudadElegidaTemp:'',
                nombreCiudad: '',
                urlBase: this.$store.state.url_base,
            }
        },
        mounted() {
            
            ciudad_api.getCiudadId(this.$store.state.ciudadElegidaID)
            .then( res => { 
                this.ciudadElegidaTemp = res
                this.nombreCiudad = this.ciudadElegidaTemp[0].name
            });

            comercio_api.getComercioIdCity(this.$store.state.ciudadElegidaID)
            .then( res => { 
                this.comercios = res

            });
        },
        methods: {
            irRestaurante: function (slug) {
                window.location.href = this.urlBase+'/'+slug;
            },
        }
    }
</script>